import React from 'react';
import { Navigate } from 'react-router-dom';
import { obterConta, obterToken } from '../../services/api';

const RotaCliente = ({ children }) => {
  const token = obterToken();
  const conta = obterConta();

  if (!token || !conta) {
    return <Navigate to="/cliente" replace />;
  }

  if (conta.role === 'admin') {
    return <Navigate to="/admin/home" replace />;
  }

  if (conta.ativo === false) {
    return <Navigate to="/cliente?erro=conta-inativa" replace />;
  }

  return children;
};

export default RotaCliente;
